import React from "react";
import UserGroups from '../../../models/UserGroups'
import RestUtilities, { IRestResponse } from '../../../services/RestUtilities'
import { Table, TableHead, TableRow, TableCell, TableBody, Checkbox } from '@mui/material'

class UserGroupsPaymentTypes extends React.Component<any, any> {

    public static TableColumns: string[] = ['Name', 'Lohnabzugberechtigt', 'Paypal']

    state = {
        data: [] as UserGroups[],
        showError: false,
        errorMessage: '',
        loading: false
    }

    fetchUserGroups = () => {
        RestUtilities.get<UserGroups[]>('/api/UserGroups')
            .then(resp => {
                let groups: UserGroups[] = resp.content as UserGroups[]
                this.setState({ data: groups })
            })
            .catch(resp => {
                this.showError(resp)
            })
    }

    updateUserGroup = (id: string, value: string, propName: string) => {
        let userGroup = this.state.data.filter(x => x.id == parseInt(id))[0]
        userGroup[propName] = (value === 'true')

        RestUtilities.put<UserGroups[]>('/api/UserGroups/Edit', userGroup)
            .then(resp => {
                let groups: UserGroups[] = resp.content as UserGroups[]
                this.setState({ data: groups })
            })
            .catch(resp => {
                this.showError(resp)
            })
    }

    mapRowCells = (group: UserGroups)=> {
        return <TableRow key={group.id}>
            <TableCell key={`${group.id}_${group.groupName}`}>{group.groupName}</TableCell>
            <TableCell key={`${group.id}_lohnabzug`}>
                <Checkbox
                    style={{ color: 'rgb(0, 155, 229)' }}
                    name='lonhabzugberechtigt'
                    inputProps={{
                        'data-id': group.id,
                      } as any}
                    checked={group.lonhabzugberechtigt}
                    onChange={(e:any) => {
                        e.target.value = e.target.checked.toString()
                        this.updateUserGroup(e.target.dataset.id, e.target.value, e.target.name)
                    }}
                ></Checkbox>
            </TableCell>
            <TableCell key={`${group.id}_paypal`}>
                <Checkbox
                    style={{ color: 'rgb(0, 155, 229)' }}
                    name='paypal'
                    inputProps={{
                        'data-id': group.id,
                      } as any}
                    checked={group.paypal}
                    onChange={(e:any) => {
                        e.target.value = e.target.checked.toString()
                        this.updateUserGroup(e.target.dataset.id, e.target.value, e.target.name)
                    }}
                ></Checkbox>
            </TableCell>
        </TableRow>
    }

    showError = (resp: IRestResponse<UserGroups>): void => {
        if(typeof resp.error_content != 'undefined' && resp.error_content) {
            this.setState({ showError: true, errorMessage: resp.error_content, loading: false })
        }
    }

    componentDidMount() {
        this.fetchUserGroups()
    }

    public render() {
        let columns: JSX.Element[] = UserGroupsPaymentTypes.TableColumns.map(x => {

            return <TableCell key={x}>{x}</TableCell>
        })
        let rows: JSX.Element[] = this.state.data.map(x => {
            return this.mapRowCells(x)
        })
        return (
            <>
                   <div className='row mt-3'>
                    <Table className="objects-table table">
                        <TableHead>
                            <TableRow>
                                {columns}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows}
                        </TableBody>
                    </Table>
                </div>
        </>
    )}
}

export default UserGroupsPaymentTypes